import { useTranslation as e } from "../../i18n.mjs";
import { FieldFeedback as t } from "../field-feedback/index.mjs";
import { toast as n } from "../toast/index.mjs";
import { formatAcceptTypeForInput as r, isAcceptTypeValid as i } from "../../utils/file-input-accept-types.mjs";
import { FileDropZoneVariantEnum as a, variantClassName as o } from "./constants.mjs";
import { Children as s, useId as c, useState as l } from "react";
import { twMerge as u } from "tailwind-merge";
import { jsx as d, jsxs as f } from "react/jsx-runtime";
import { UploadCloud02Icon as p } from "@systemeio/icons";
//#region src/components/file-drop-zone/index.tsx
function m(m) {
	let { acceptTypes: h, children: g, dropZoneClassName: _, className: v, disabled: y, error: b, variant: x = a.Medium, label: S, description: C, icon: w, isPreFetching: T, toastText: E, labelClassName: D, openNativeWindow: O = !0, multiple: k = !1, displayItemsInGrid: A = !1, onSelect: j, onClick: M } = m, N = T || y, P = x === a.Big, F = !!s.count(g), I = S == null || !!S || !!C, { t: L } = e(), R = c(), [z, B] = l(!1), [V, H] = l(), U = (e) => {
		(N || !O) && e.preventDefault(), !N && M?.();
	}, W = (e) => {
		(e.key === " " || e.key === "Enter") && (e.preventDefault(), M?.());
	}, G = (e) => {
		let t = [], r = [];
		for (let n of e) h && !i(n.type, h) ? t.push(`${n.name} - ${L("file_manager.file_upload.file_not_supported")}`, /* @__PURE__ */ d("br", {})) : r.push(n);
		H(t), r.length && (j(r), E && n.success(E));
	}, K = (e) => {
		e.preventDefault(), B(!0);
	};
	return /* @__PURE__ */ f("div", {
		className: u("font-medium", v),
		children: [
			/* @__PURE__ */ d("input", {
				id: R,
				type: "file",
				className: "peer sr-only",
				onChange: (e) => {
					e.target.files && G(e.target.files), e.target.value = "";
				},
				disabled: N || !O,
				accept: h && r(h),
				multiple: k
			}),
			/* @__PURE__ */ f("div", {
				className: u("peer-focus-visible:focus-ring-primary has-[label:focus-visible]:focus-ring-primary transition-base relative isolate flex min-h-[60px] w-full cursor-pointer flex-col items-center justify-center gap-1 overflow-hidden rounded-md border border-dashed outline-none", N ? "bg-bg-primary border-border-200" : z ? "bg-bg-accent border-border-accent" : "bg-bg-secondary border-border-accent hover:bg-bg-tertiary", o[x], T && "animate-pulse", N && "cursor-not-allowed", _),
				onDragStart: N ? void 0 : K,
				onDragLeave: N ? void 0 : (e) => {
					e.preventDefault(), B(!1);
				},
				onDrop: N ? void 0 : (e) => {
					e.preventDefault(), e.stopPropagation();
					let { files: t } = e.dataTransfer;
					if (k) G(t);
					else {
						let e = t[0];
						e && G([e]);
					}
					B(!1);
				},
				onDragOver: N ? void 0 : K,
				children: [F && (A ? /* @__PURE__ */ d("div", {
					onClick: (e) => e.stopPropagation(),
					className: "relative z-10 grid w-full [grid-template-columns:repeat(auto-fit,minmax(200px,1fr))] content-start gap-x-8 gap-y-6",
					children: g
				}) : /* @__PURE__ */ d("div", {
					className: "relative z-10 flex w-full flex-wrap gap-3",
					onClick: (e) => e.stopPropagation(),
					children: g
				})), /* @__PURE__ */ f("label", {
					htmlFor: R,
					"aria-disabled": N,
					onClick: U,
					onKeyDown: O ? void 0 : W,
					role: O ? void 0 : "button",
					tabIndex: !O && !N ? 0 : void 0,
					className: u("text-text-primary flex w-full flex-col items-center justify-center gap-1 text-sm font-normal outline-none before:absolute before:inset-0 before:z-0 before:content-[''] [&>*]:relative [&>*]:z-10", F && "flex-1", N && "text-text-disabled", D),
					children: [
						w === null ? null : w || /* @__PURE__ */ d("div", {
							className: u("bg-bg-primary border-border-200 flex items-center justify-center rounded-lg border", I && "mb-1", P ? "size-15" : "size-10"),
							children: /* @__PURE__ */ d(p, {
								"aria-hidden": !0,
								className: u(N ? "text-icon-disabled" : "text-icon-accent", P ? "size-11" : "size-6")
							})
						}),
						S == null ? /* @__PURE__ */ d("span", { children: L("file_manager.file_upload.drop_files_here") }) : S ? /* @__PURE__ */ d("div", { children: S }) : null,
						C ? /* @__PURE__ */ d("span", {
							className: u("text-xs font-normal", N ? "text-text-quaternary" : "text-text-tertiary"),
							children: C
						}) : null
					]
				})]
			}),
			/* @__PURE__ */ d(t, {
				error: V,
				errorClassName: "mt-2 text-center"
			}),
			/* @__PURE__ */ d(t, {
				error: b,
				errorClassName: "mt-2 text-center"
			})
		]
	});
}
//#endregion
export { m as FileDropZone };
